import React, { useState } from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptOwnershipTransfer,
  initOrganizations,
  organizationsSliceSelector,
  setSnoozedOwnershipTransfer,
  updateOwnershipTransfer,
} from "../../../../redux/features/organizationsSlice";
import ConfirmationDialog from "../../../ConfirmationDialog";
import { Timestamp } from "firebase/firestore";
import LoadingOverlay from "../../../LoadingOverlay";

const AcceptOwnershipTransfer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const organizationsState = useSelector((state) =>
    organizationsSliceSelector(state),
  );
  const [confirmShow, setConfirmShow] = useState(false);
  const { myOwnershipTransfersMap } = organizationsState;
  const { transferId } = params;

  if (!transferId) {
    return null;
  }

  const transfer = myOwnershipTransfersMap?.[transferId];

  if (!transfer) {
    return null;
  }

  const { organizationId, accepting } = transfer;
  return (
    <Container>
      <LoadingOverlay show={accepting} />
      <ConfirmationDialog
        open={confirmShow}
        title={"Decline Ownership Transfer"}
        message={
          "Are you sure you want to decline this ownership transfer? This action is irreversible"
        }
        handleConfirm={async () => {
          const nowTimestamp = Timestamp.now();
          await dispatch(
            updateOwnershipTransfer({
              organizationId,
              transferId,
              values: { declinedAt: nowTimestamp },
            }),
          );
          await dispatch(initOrganizations());
          navigate("/");
        }}
        handleCancel={() => {
          setConfirmShow(false);
        }}
      />
      <Box
        sx={{
          marginTop: "30px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h2" paddingTop={"20px"}>
          Ownership transfer
        </Typography>
        <Typography marginTop={"40px"}>
          You have been offered ownership of
        </Typography>
        <Typography variant="h2">{transfer.organizationName}</Typography>
        <Typography marginTop={"20px"} textAlign={"center"}>
          Accepting makes you the owner and removes the previous owner from the
          organization.
        </Typography>
        <Box
          marginTop={"20px"}
          display={"flex"}
          flexDirection={"column"}
          gap={"20px"}
        >
          <Button
            variant="contained"
            sx={{ width: "200px" }}
            data-testid="accept-ownership-transfer"
            onClick={async () => {
              try {
                await dispatch(
                  acceptOwnershipTransfer({
                    transferId,
                    organizationId,
                  }),
                ).unwrap();
                await dispatch(initOrganizations());
                navigate("/");
              } catch (e) {
                // The overlay clears when acceptance fails so the user can retry.
              }
            }}
          >
            Accept
          </Button>
          <Button
            color="error"
            size="small"
            data-testid="decline-ownership-transfer"
            onClick={() => {
              setConfirmShow(true);
            }}
          >
            Decline
          </Button>
          <Button
            color="secondary"
            size="small"
            data-testid="snooze-ownership-transfer"
            onClick={async () => {
              dispatch(
                setSnoozedOwnershipTransfer({ transferId, snoozed: true }),
              );
              navigate("/");
            }}
          >
            Not Now
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default AcceptOwnershipTransfer;
